import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad kostar en ansökan om serveringstillstånd?";
const SHORT_ANSWER = "Avgiften sätts av varje kommun – stadigvarande tillstånd ligger oftast på 8 000–14 000 kr i ansökningsavgift och därefter en årlig tillsynsavgift kopplad till omsättning.";

export const Route = createFileRoute("/fraga/vad-kostar-ansokan")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad kostar en ansökan om serveringstillstånd" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Kommunerna får ta ut avgift enligt 8 kap. 10 § alkohollagen. Avgifterna varierar kraftigt – Stockholm, Göteborg och Malmö ligger högre, mindre kommuner lägre. Tillfälligt tillstånd kostar normalt 1 000–6 000 kr. Räkna också med tillsynsavgift varje år."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsbank/vad-kostar-serveringstillstand", label: "Vad kostar serveringstillstånd – fullständig prislista" }}
      related={[{"to": "/fraga/hur-lang-handlaggningstid", "label": "Hur lång är handläggningstiden för serveringstillstånd?"}, {"to": "/fraga/vilka-dokument-kravs", "label": "Vilka dokument krävs i ansökan om serveringstillstånd?"}, {"to": "/fraga/vilka-typer-av-serveringstillstand-finns", "label": "Vilka typer av serveringstillstånd finns?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad kostar en ansökan om serveringstillstånd?" },
      { name: "description", content: "Avgiften sätts av varje kommun – stadigvarande tillstånd ligger oftast på 8 000–14 000 kr i ansökningsavgift och därefter en årlig tillsynsavgift kopplad til…" },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-kostar-ansokan" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-kostar-ansokan" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-kostar-ansokan",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad kostar en ansökan om serveringstillstånd", url: "https://alkoholprovet.se/fraga/vad-kostar-ansokan" },
      ]),
    ],
  }),
});
